//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoListBasic from './demos/DemoListBasic.vue'
import DemoListDense from './demos/DemoListDense.vue'
import DemoListFlat from './demos/DemoListFlat.vue'
import DemoListNav from './demos/DemoListNav.vue'
import DemoListRounded from './demos/DemoListRounded.vue'
import DemoListShaped from './demos/DemoListShaped.vue'
import DemoListSubGroup from './demos/DemoListSubGroup.vue'
import DemoListTwoLinesAndSubheader from './demos/DemoListTwoLinesAndSubheader.vue'
import DemoListExpansionList from './demos/DemoListExpansionList.vue'
import DemoListActionAndItemGroup from './demos/DemoListActionAndItemGroup.vue'
import DemoListActionStack from './demos/DemoListActionStack.vue'
import DemoListThreeLine from './demos/DemoListThreeLine.vue'

// code
import {
  listBasic,
  listDense,
  listFlat,
  listNav,
  listRounded,
  listShaped,
  listSubGroup,
  listTwoLinesAndSubheader,
  listExpansionList,
  listActionAndItemGroup,
  listActionStack,
  listThreeLine,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoListBasic,
    DemoListDense,
    DemoListFlat,
    DemoListNav,
    DemoListRounded,
    DemoListShaped,
    DemoListSubGroup,
    DemoListTwoLinesAndSubheader,
    DemoListExpansionList,
    DemoListActionAndItemGroup,
    DemoListActionStack,
    DemoListThreeLine,
  },
  setup() {
    return {
      codeSnippets: {
        listBasic,
        listDense,
        listFlat,
        listNav,
        listRounded,
        listShaped,
        listSubGroup,
        listTwoLinesAndSubheader,
        listExpansionList,
        listActionAndItemGroup,
        listActionStack,
        listThreeLine,
      },
    }
  },
}
